<template>
    <div class="MenuResponsive" v-click-outside="close">
        <div class="MenuResponsive-Circle" id="MenuResponsive-Circle" @click="toggle">
            <img src="/img/global/hamburger.svg" alt="Menu Responsive Icon" />
        </div>
        <div class="MenuResponsive-Container hide">
            <div class="MenuResponsive-Container-Logo">
                <router-link class="Logo" to="/" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                    <img src="/img/global/logo/logo.svg" alt="JobStream Logo" />
                </router-link>
            </div>
            <div class="MenuResponsive-Container-Links">
                <div class="MenuResponsive-Links">
                    <a @click="openSub(0)">
                        <img src="/img/global/arrowLeft.svg" alt="Arrow Left" />
                        <span>Conseil</span>
                    </a>
                    <div class="MenuResponsive-SubLinks hide">
                        <router-link to="/conseil/recrutement" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                            Recrutement et intégration des salariés
                        </router-link>
                        <router-link to="/conseil/accompagnement" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                            Accompagnement de l'entreprise et des salariés
                        </router-link>
                        <router-link to="/conseil/externalisation" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                            Externalisation des Entretiens Professionnels
                        </router-link>
                    </div>
                </div>
                <div class="MenuResponsive-Links">
                    <router-link to="/formation" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                        Formation
                    </router-link>
                </div>
                <div class="MenuResponsive-Links">
                    <a @click="openSub(1)">
                        <img src="/img/global/arrowLeft.svg" alt="Arrow Left" />
                        <span>Évolution professionnelle</span>
                    </a>
                    <div class="MenuResponsive-SubLinks hide">
                        <router-link to="/evolution/accompagnement" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                            Accompagnement vers et dans l'emploi
                        </router-link>
                        <router-link to="/evolution/bilan" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                            Bilan de compétences
                        </router-link>
                        <router-link to="/evolution/validation" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                            Validation des Acquis de l'Expérience (VAE)
                        </router-link>
                    </div>
                </div>
                <div class="MenuResponsive-Links">
                    <a @click="openSub(2)">
                        <img src="/img/global/arrowLeft.svg" alt="Arrow Left" />
                        <span>Nous connaitre</span>
                    </a>
                    <div class="MenuResponsive-SubLinks hide">
                        <router-link to="/nous-connaitre/jobstream" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                            JobStream
                        </router-link>
                        <router-link to="/nous-connaitre/equipe" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                            L'équipe
                        </router-link>
                        <router-link to="/nous-connaitre/nous-rejoindre" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                            Nous rejoindre
                        </router-link>
                        <router-link to="/nous-connaitre/engagement-qualite" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                            Notre engagement qualité
                        </router-link>
                        <router-link to="/nous-connaitre/confiance" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                            Ils nous font confiance
                        </router-link>
                        <router-link to="/nous-connaitre/partenaires" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                            Nos partenaires
                        </router-link>
                    </div>
                </div>
                <div class="MenuResponsive-Links">
                    <router-link to="/contact" @click.native="toggle(); $scrollToTop(); closeSub(); checkActive();">
                        Contact
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'MenuResponsive',
  props: ['side'],
  mounted() {
        if(this.side == "left") {
            document.getElementById('MenuResponsive-Circle').style.left = '20px';
            document.getElementsByClassName('MenuResponsive-Container')[0].style.left = '0px';
            document.getElementsByClassName('MenuResponsive-Container')[0].style.borderBottomRightRadius = '5px';
        } else {
            document.getElementById('MenuResponsive-Circle').style.right = '20px';
            document.getElementsByClassName('MenuResponsive-Container')[0].style.right = '0px';
            document.getElementsByClassName('MenuResponsive-Container')[0].style.borderBottomLeftRadius = '5px';
        }
        this.checkActive();
  },
  methods: {
    toggle() {
        document.getElementsByClassName('MenuResponsive-Container')[0].classList.toggle("hide");
    },
    close() {
        document.getElementsByClassName('MenuResponsive-Container')[0].classList.add("hide");
    },
    openSub(id) {
        const conseil = document.getElementsByClassName('MenuResponsive-Links')[0];
        const evol = document.getElementsByClassName('MenuResponsive-Links')[2];
        const connaitre = document.getElementsByClassName('MenuResponsive-Links')[3];

        if(id == 0) {
            conseil.classList.toggle('openSub');
            evol.classList.remove('openSub');
            connaitre.classList.remove('openSub');
        } else if(id == 1) {
            conseil.classList.remove('openSub');
            evol.classList.toggle('openSub');
            connaitre.classList.remove('openSub');
        } else if(id == 2) {
            conseil.classList.remove('openSub');
            evol.classList.remove('openSub');
            connaitre.classList.toggle('openSub');
        }
        this.checkActive();
    },
    checkActive() {
        const conseil = document.getElementsByClassName('MenuResponsive-Links')[0];
        const evol = document.getElementsByClassName('MenuResponsive-Links')[2];
        const connaitre = document.getElementsByClassName('MenuResponsive-Links')[3];
        conseil.classList.remove('currentSub');
        evol.classList.remove('currentSub');
        connaitre.classList.remove('currentSub');
        for(let i = 0; i < conseil.children[1].children.length; i++) {
            if(conseil.children[1].children[i].classList.contains('router-link-active')) {
                conseil.classList.add('currentSub');
            }
        }
        for(let i = 0; i < evol.children[1].children.length; i++) {
            if(evol.children[1].children[i].classList.contains('router-link-active')) {
                evol.classList.add('currentSub');
            }
        }
        for(let i = 0; i < connaitre.children[1].children.length; i++) {
            if(connaitre.children[1].children[i].classList.contains('router-link-active')) {
                connaitre.classList.add('currentSub');
            }
        }
    },
    closeSub()  {
        const conseil = document.getElementsByClassName('MenuResponsive-Links')[0];
        const evol = document.getElementsByClassName('MenuResponsive-Links')[2];
        const connaitre = document.getElementsByClassName('MenuResponsive-Links')[3];
        conseil.classList.remove('openSub');
        evol.classList.remove('openSub');
        connaitre.classList.remove('openSub');
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style scoped>
/* 
* Global
*/
.MenuResponsive * {
    font-size: 12px !important;
}

a {
    color: black;
    text-decoration: none;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
    height: 25px;
}

a:not(.Logo) img {
    position: absolute;
    left: 20px;
}

.MenuResponsive, .hide {
    display: none !important;
}

.MenuResponsive {
    width: 250px;
    height: auto;
}

.MenuResponsive-Container {
    z-index: 10;
    position: absolute;
    background-color: #FFFFFF;
    box-shadow: 0px 10px 30px 5px rgba(119, 119, 119, 0.1);
    width: 250px;
    padding-bottom: 30px;
    overflow: hidden;
}

.MenuResponsive-Container-Logo {
    padding: 30px 0;
}

.MenuResponsive-Container, .MenuResponsive-Container-Links, .MenuResponsive-Links, .MenuResponsive-Links div {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
}

/* 
* Links 
*/
.MenuResponsive-Container-Links {
   width: 100%;
   align-items: flex-end;
}

.MenuResponsive-Links {
    width: 100%;
}

.MenuResponsive-Links > a {
    padding: 10px 75px 10px 0px;
    width: 100%;
    text-align: end;
    cursor: pointer;
}

.MenuResponsive-Links:hover {
    background-color: rgba(0, 174, 176, 0.05);
}   

.router-link-active:hover, .openSub:hover, .currentSub:hover {
    background-color: transparent;
}

.router-link-active:not(.Logo) {
    background-color: rgba(0, 174, 176, 0.05);
}

.MenuResponsive-Links > .router-link-active:before,
.openSub .MenuResponsive-Links > .router-link-active:before,
.openSub > a:before {
    content: '';
    height: 42px;
    position: absolute;
    border: 2px solid #00AEB0;
    background-color: #00AEB0;
    left: 0;
}

 .MenuResponsive-Links > .router-link-active:after {
    width: 0% !important;
} 

.hide {
    display: none;
}

.currentSub > a {
    background-color: rgba(0, 174, 176, 0.05);
}

.currentSub > a:before {
    content: '';
    height: 42px;
    position: absolute;
    border: 2px solid #00AEB0;
    background-color: #00AEB0;
    left: 0;
}

.openSub .hide {
    display: inline-block !important;
}

.openSub > a > img {
    transform: rotate(-90deg);
}

.openSub > a {
    background-color: rgba(0, 174, 176, 0.05);
}

.MenuResponsive-SubLinks {
    width: 100%;
}

.MenuResponsive-SubLinks > a {
    width: 80%;
    text-align: end;
    padding: 14px 26px;
}

.MenuResponsive-SubLinks > a:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

/* 
* Menu Button 
*/
.MenuResponsive-Circle img {
    width: 35px;
    position: relative;
    left: 50%;
    top: 22%;
    transform: translateX(-50%);
}

.MenuResponsive-Circle {
    background: #FFFFFF;
    position: absolute;
    top: 20px;
    border-radius: 100%;
    width: 60px;
    height: 60px;
    box-shadow: 0px 10px 30px 5px rgba(119, 119, 119, 0.2);
}

/* 
* Responsive
*/ 
@media (max-width: 1135px) {
    /* 
    *   Global
    */
    .MenuResponsive {
        display: inline-block !important;
    }
}

@media (max-width: 630px) {
    /* 
    *   Global
    */
    .MenuResponsive {
        width: 100%;
    }
}
</style>